/* istanbul ignore file */

/*
    Format of the option object for the react-select control:
    {
        value: '',
        label: '',
        isDisabled: false
    }
*/

export const allOptions = {
    region: { value: 'all', label: 'All Regions', isDisabled: false },
    subMarket: { value: 'all', label: 'All SubMarkets', isDisabled: false },
    projectType: { value: 'all', label: 'All Types', isDisabled: false },
    totalSqFt: { value: 'all', label: 'All Totals', isDisabled: false },
};

export default {
    projectType: [
        allOptions.projectType,
        { value: 'in_service', label: 'IN-SERVICE', isDisabled: false  },
        { value: 'development', label: 'DEVELOPMENT', isDisabled: false  },
        { value: 'redevelopment', label: 'REDEVELOPMENT', isDisabled: false  },
    ],
    totalSqFt: [
        allOptions.totalSqFt,
        // Use the min sq ft for the value
        { value: 0, label: '< 49,999', isDisabled: false  },
        { value: 50000, label: '50 - 99,999', isDisabled: false  },
        { value: 100000, label: '100 - 249,999', isDisabled: false  },
        { value: 250000, label: '250 - 499,999', isDisabled: false  },
        { value: 500000, label: '500 - 999,999', isDisabled: false  },
        { value: 1000000, label: '1,000,000+', isDisabled: false  },
    ],
};

// { value: 'repositioning', label: 'REPOSITIONING', isDisabled: false  },